<script>
import axios from '@/utils/axios';

export default {
  name: 'HrmAssetModal',
  inject: ['setLoading'],
  props: {
    asset: { type: Object, default: null },
    categories: { type: Array, default: () => [] },
  },
  emits: ['saved'],
  data() {
    return {
      errors: {},
      form: this.emptyForm(),
    };
  },

  computed: {
    isEdit() {
      return !!(this.asset && this.asset.id);
    },
  },

  watch: {
    asset: {
      immediate: true,
      handler(val) {
        this.errors = {};
        this.form = val ? {
          asset_category_id: val.asset_category_id,
          name: val.name,
          code: val.code,
          is_trackable: !!val.is_trackable,
          serial_number: val.serial_number,
          quantity: val.quantity,
          purchase_price: val.purchase_price,
          purchase_date: val.purchase_date,
          brand: val.brand,
          model: val.model,
          description: val.description,
        } : this.emptyForm();
      },
    },
  },

  methods: {
    emptyForm() {
      return {
        asset_category_id: '',
        name: '',
        code: '',
        is_trackable: true,
        serial_number: '',
        quantity: 1,
        purchase_price: null,
        purchase_date: '',
        brand: '',
        model: '',
        description: '',
      };
    },

    async submit() {
      this.errors = {};
      this.setLoading(true);
      try {
        if (this.isEdit) {
          await axios.put(`/hrms/assets/${this.asset.id}`, this.form);
          this.$swalToast('Asset updated successfully.');
        } else {
          await axios.post('/hrms/assets', this.form);
          this.$swalToast('Asset added successfully.');
        }
        this.$closeModal('hrm_asset_modal');
        this.$emit('saved');
      } catch (error) {
        if (error.type == 'validation') {
          this.errors = error.errors;
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },
  }
};
</script>

<template>
  <div class="modal fade" id="hrm_asset_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ isEdit ? 'Edit Asset' : 'Add Asset' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">

          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Asset Name <span class="text-danger">*</span></label>
              <input type="text" class="form-control" v-model="form.name" placeholder="e.g. HP i3 Laptop">
              <span class="text-danger" style="font-size:12px;" v-if="errors.name">{{ errors.name[0] }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Asset Code <span class="text-danger">*</span></label>
              <input type="text" class="form-control" v-model="form.code" placeholder="e.g. HP001">
              <span class="text-danger" style="font-size:12px;" v-if="errors.code">{{ errors.code[0] }}</span>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Category <span class="text-danger">*</span></label>
              <vue-select v-model="form.asset_category_id" :options="categories" label="name" :reduce="c => c.id"
                placeholder="Select Category"></vue-select>
              <span class="text-danger" style="font-size:12px;" v-if="errors.asset_category_id">{{ errors.asset_category_id[0] }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Serial Number</label>
              <input type="text" class="form-control" v-model="form.serial_number">
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 mb-3">
              <label class="form-label">Brand</label>
              <input type="text" class="form-control" v-model="form.brand">
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label">Model</label>
              <input type="text" class="form-control" v-model="form.model">
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label">Quantity <span class="text-danger">*</span></label>
              <input type="number" class="form-control" v-model.number="form.quantity" min="1">
              <span class="text-danger" style="font-size:12px;" v-if="errors.quantity">{{ errors.quantity[0] }}</span>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Purchase Price</label>
              <input type="number" class="form-control" v-model.number="form.purchase_price" min="0">
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Purchase Date</label>
              <input type="date" class="form-control" v-model="form.purchase_date">
            </div>
          </div>

          <div class="mb-3">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" id="is_trackable" v-model="form.is_trackable">
              <label class="form-check-label" for="is_trackable">Track individually (serial-based asset)</label>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">Description</label>
            <textarea class="form-control" rows="3" v-model="form.description"></textarea>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" :disabled="!form.name || !form.code" @click="submit">
            {{ isEdit ? 'Update Asset' : 'Add Asset' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>